import React from "react";
import { CheckCircleIcon } from "@phosphor-icons/react";
import "./auth.css";

interface MagicLinkSentProps {
  email: string;
  onBackToLogin: () => void;
}

const MagicLinkSent: React.FC<MagicLinkSentProps> = ({
  email,
  onBackToLogin,
}) => {
  return (
    <div className="magic-link-container">
      <CheckCircleIcon size={48} weight="fill" className="success-icon" />

      <h1 className="magic-link-title">Link di accesso inviato!</h1>

      <div className="magic-link-message">
        <p>
          Abbiamo inviato un link di accesso magico all'indirizzo{" "}
          <span className="email-highlight">{email}</span>.
        </p>

        <p>
          Controlla la tua casella di posta elettronica e clicca sul link per
          accedere.
        </p>

        <div className="email-tips">
          <h4>Non trovi l'email?</h4>
          <ul>
            <li>Controlla la cartella spam o posta indesiderata</li>
            <li>Il link è valido per 15 minuti</li>
            <li>Assicurati che l'indirizzo email sia corretto</li>
            <li>Prova a cercare "CosaVorrei" nella tua casella di posta</li>
          </ul>
        </div>
      </div>

      <button onClick={onBackToLogin} className="back-button">
        Torna al login
      </button>
    </div>
  );
};

export default MagicLinkSent;
